import { ExecuteCommandPayload } from '@types'

export const generateCommandCacheKey = (params: ExecuteCommandPayload): string => {
  const { commandCode, objectCode, filter, page, size, sort, expands, params: queryParams } = params

  const queryParts: string[] = []

  if (filter) queryParts.push(`filter=${encodeURIComponent(filter)}`)
  if (page !== undefined) queryParts.push(`page=${page}`)
  if (size !== undefined) queryParts.push(`size=${size}`)
  if (sort?.length) queryParts.push(`sort=${sort.join(',')}`)
  if (expands?.length) queryParts.push(`expands=${expands.join(',')}`)
  if (queryParams) {
    Object.entries(queryParams).forEach(([key, value]) => {
      queryParts.push(`${key}=${value}`)
    })
  }

  const queryString = queryParts.length > 0 ? `?${queryParts.join('&')}` : ''

  return `/command/objects/${objectCode}/${commandCode}${queryString}`
}
